const mealVideoPopUpTranslations = {
    cancel:'الغاء',
}

export default  mealVideoPopUpTranslations;